var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.722,
    height: 55.316,
    viewBox: "0 0 35.722 55.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_29",
    "data-name": "Intersection 29",
    d: "M4.281,55.316A4.286,4.286,0,0,1,0,51.035V4.282A4.286,4.286,0,0,1,4.281,0H31.442a4.286,4.286,0,0,1,4.28,4.209v46.9a4.286,4.286,0,0,1-4.28,4.208ZM1.26,51.035a3.024,3.024,0,0,0,3.021,3.021H31.442a3.023,3.023,0,0,0,3.02-3.021v-4.1H1.26Zm0-5.359h33.2V9.168H1.26Zm0-41.393V7.908h33.2V4.282a3.024,3.024,0,0,0-3.02-3.022H4.281A3.025,3.025,0,0,0,1.26,4.282Zm15.4,46.785a.63.63,0,1,1,0-1.261h2.413a.63.63,0,1,1,0,1.261ZM10.19,39.091a1.454,1.454,0,0,1-.537-1.649l2.269-6.98L5.985,26.146a1.474,1.474,0,0,1,.866-2.666h7.34l2.267-6.98a1.474,1.474,0,0,1,2.805,0l2.268,6.98h7.339a1.474,1.474,0,0,1,.867,2.666L23.8,30.461l2.268,6.98A1.475,1.475,0,0,1,23.8,39.09l-5.938-4.315L11.924,39.09a1.453,1.453,0,0,1-1.734,0Zm8.042-5.6L24.54,38.07a.2.2,0,0,0,.251,0,.2.2,0,0,0,.079-.24l-2.409-7.417a.629.629,0,0,1,.228-.7L29,25.127a.214.214,0,0,0-.126-.388h-7.8a.631.631,0,0,1-.6-.436l-2.409-7.416a.215.215,0,0,0-.409,0L15.248,24.3a.629.629,0,0,1-.6.436h-7.8a.214.214,0,0,0-.126.388l6.309,4.583a.631.631,0,0,1,.228.7l-2.41,7.417a.214.214,0,0,0,.33.239l6.308-4.583a.632.632,0,0,1,.741,0ZM14.97,5.51a.63.63,0,0,1,0-1.261h5.784a.63.63,0,0,1,0,1.261Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.b7f22dc08924078b897739e32ed8d6c6.svg";
export { ForwardRef as ReactComponent };